/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { api } from './config';

export class Shop {
  async getPhoneAdm<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getRating<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async indexRequests<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getRequest<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getShop<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getMenuItensShop<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getResultCalcVlCart<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async sendRequest<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getParamsShop<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async getValueDelivery<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async indexSegments<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async indexPromotions<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async indexShops<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async indexExplore<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async uploadFile<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_upload_oapi.php', data);
  }

  async getOldOrder<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }
}
